import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo, useLayoutEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { ModalAllder } from "layouts/ModalAllder";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { defaultOption } from "constants/ui/options";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { getAllNewPurchaseReq } from "../../redux/handlers/logic/getAllNewPurchaseReq.handler";
import { getSupplierFullName, mapMstToOptions } from "utils/HelperFunction";
import { PRstatus } from "fragments/PRStatus";
import { ref } from "yup";
import moment from "moment";
import { NumericFormat } from "react-number-format";
export default function LoadPR(_param) {
    var setFormdata = _param.setFormdata, setProductRow = _param.setProductRow, setPdata = _param.setPdata, setModal = _param.setModal, props = _object_without_properties(_param, [
        "setFormdata",
        "setProductRow",
        "setPdata",
        "setModal"
    ]);
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState1[0], setOptionsDistributorgroup = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState2[0], setOptionsGroupOfSuplier = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState3[0], setSelectedGroupOfSuplierID = _useState3[1];
    var _useState4 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState4[0], setGroupOfSupplier = _useState4[1];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewPurchaseReqReducer = useAppSelector(function(state) {
        return state.getAllNewPurchaseReqReducer;
    });
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function() {
        var queryParams = {
            isIncludeItems: "true",
            mstNewStatusID: 3
        };
        dispatch(getAllNewPurchaseReq({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        getData();
        loadAllMsts();
    }, []);
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewPurchaseReqReducer.isFetching);
        if (getAllNewPurchaseReqReducer.data) {
            var result = getAllNewPurchaseReqReducer.data.data;
            setData(result);
        }
    }, [
        getAllNewPurchaseReqReducer
    ]);
    var filteredItems = data.filter(function(item) {
        var docNumberMatches = item.doc_number && item.doc_number.toLowerCase().includes(filterText.toLowerCase());
        var supplierNameMatches = item.dimSupplierInformation && (getSupplierFullName(item.dimSupplierInformation).toLowerCase().includes(filterText.toLowerCase()) || item.dimSupplierInformation.initials.toLowerCase().includes(filterText.toLowerCase()));
        //   const supplierGroupMatches = !selectedGroupOfSuplierID || (
        //     item.dimSupplierInformation &&
        //     item.dimSupplierInformation.dimGroupOfSupplier &&
        //     (selectedGroupOfSuplierID === item.dimSupplierInformation.dimGroupOfSupplier.id)
        //   );
        return docNumberMatches || supplierNameMatches;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), anchorEl = _React_useState[0], setAnchorEl = _React_useState[1];
    var _useState6 = _sliced_to_array(useState(null), 2), popid = _useState6[0], setPopid = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), prSelected = _useState7[0], setPrSelected = _useState7[1];
    var colum = [
        {
            field: "id",
            headerName: "",
            width: 100,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Form.Check, {
                    type: "radio",
                    id: "t".concat(row.id),
                    className: "form-check-st-2 tc-7 ms-4",
                    checked: prSelected && prSelected.id == row.id,
                    onChange: function(e) {
                        setPrSelected(row);
                    }
                });
            }
        },
        {
            field: "doc_number",
            headerName: "เลขที่ใบขอซื้อ",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF"
                        },
                        children: row.doc_number
                    })
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จำหน่าย",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    color: "#8E8E8F"
                                },
                                children: row.dimSupplierInformation.initials
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "dimNewPurchaseReqItem",
            headerName: "รายการสินค้า",
            width: 200,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                if (row.dimNewPurchaseReqItem && row.dimNewPurchaseReqItem.length > 0) {
                    var handlePopoverOpen = function(event) {
                        setAnchorEl(event.currentTarget);
                    };
                    var handlePopoverClose = function() {
                        setAnchorEl(null);
                    };
                    return /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                "aria-owns": open ? "mouse-over-popover" : undefined,
                                "aria-haspopup": "true",
                                onMouseEnter: function(event) {
                                    setAnchorEl(event.currentTarget);
                                    setPopid(row.id);
                                },
                                onMouseLeave: function(event) {
                                    setAnchorEl(null);
                                    setPopid(null);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: row.dimNewPurchaseReqItem[0] && row.dimNewPurchaseReqItem[0].dimProductPrice && row.dimNewPurchaseReqItem[0].dimProductPrice.dimProduct ? row.dimNewPurchaseReqItem[0].dimProductPrice.dimProduct.name_th : "-"
                                    }),
                                    row.dimNewPurchaseReqItem.length > 1 ? /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            " ",
                                            "และอีก ",
                                            row.dimNewPurchaseReqItem.length - 1,
                                            " รายการ",
                                            " "
                                        ]
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Popover, {
                                id: "mouse-over-popover",
                                sx: {
                                    pointerEvents: "none"
                                },
                                open: popid == row.id,
                                anchorEl: anchorEl,
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                onClose: handlePopoverClose,
                                disableRestoreFocus: true,
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    sx: {
                                        p: 1
                                    },
                                    children: row.dimNewPurchaseReqItem.map(function(item, index) {
                                        return /*#__PURE__*/ _jsx("div", {
                                            children: item.dimProductPrice && item.dimProductPrice.dimProduct ? item.dimProductPrice.dimProduct.name_th : "-"
                                        }, "popover-id-".concat(item.id));
                                    })
                                })
                            })
                        ]
                    });
                }
                return "";
            }
        },
        {
            field: "qty_sum",
            headerName: "จำนวน",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 0,
                    fixedDecimalScale: true,
                    value: row.qty_sum
                });
            }
        },
        {
            field: "delivery_date",
            headerName: "วันที่ส่งมอบ",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.delivery_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "ยอดรวม",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price
                });
            }
        },
        {
            field: "dimMstNewStatus",
            headerName: "สถานะ",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row ? row.dimMstNewStatus.id : "";
                var statusName = row ? row.dimMstNewStatus.name : "";
                return /*#__PURE__*/ _jsx(PRstatus, {
                    statusID: statusID,
                    statusName: statusName
                });
            }
        }
    ];
    var open = Boolean(anchorEl);
    var loadPrData = function() {
        if (prSelected) {
            var datas = prSelected;
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _$_param = _sliced_to_array(param, 2), key = _$_param[0], value = _$_param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements.dimSupplierInformation) {
                var dimSupplierInformation = dataWithReplacements.dimSupplierInformation;
                var full_supplier_name = dataWithReplacements.full_supplier_name, full_supplier_address_name = dataWithReplacements.full_supplier_address_name;
                setPdata(function(prev) {
                    return {
                        id: dimSupplierInformation.id,
                        dimGroupOfSupplierCode: dimSupplierInformation.dimGroupOfSupplier ? dimSupplierInformation.dimGroupOfSupplier.code : "-",
                        full_supplier_name: full_supplier_name,
                        initials: dimSupplierInformation.initials,
                        company_branch_code: dimSupplierInformation.company_branch_code,
                        company_branch_name: dimSupplierInformation.company_branch_name,
                        full_supplier_address_name: full_supplier_address_name,
                        company_phone_number: dimSupplierInformation.company_phone_number
                    };
                });
            }
            if (dataWithReplacements.dimNewPurchaseReqItem && dataWithReplacements.dimNewPurchaseReqItem.length > 0) {
                var productItems = dataWithReplacements.dimNewPurchaseReqItem.map(function(v) {
                    var _dimProductPrice_dimProduct, _dimProductPrice_dimProduct1;
                    var dim_product_price_id = v.dim_product_price_id, quantity = v.quantity, unit_price = v.unit_price, unit_id = v.unit_id, ratio_unit = v.ratio_unit, container = v.container, dim_mst_discount_type_id = v.dim_mst_discount_type_id, remark = v.remark, discount_value = v.discount_value, discount_price = v.discount_price, dimWarehouse = v.dimWarehouse, dimProductPrice = v.dimProductPrice, dimMasterUnit = v.dimMasterUnit, dimMstVat = v.dimMstVat;
                    //   console.log(discount_price);
                    var mappingData = {
                        rowID: nanoid(),
                        productID: dim_product_price_id,
                        productCode: (_dimProductPrice_dimProduct = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct === void 0 ? void 0 : _dimProductPrice_dimProduct.sku,
                        productName: (_dimProductPrice_dimProduct1 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct1 === void 0 ? void 0 : _dimProductPrice_dimProduct1.name_th,
                        productBarcode: dimProductPrice.barcode,
                        productUnitID: unit_id,
                        productRatioUnit: ratio_unit,
                        productContainer: container,
                        supplierCode: "",
                        warehouseID: dimWarehouse.id,
                        warehouseName: dimWarehouse.name,
                        productUnit: dimMasterUnit ? dimMasterUnit.name : "-",
                        productQty: quantity,
                        productOrdered: "",
                        ums: "",
                        productStock: "",
                        productPrice: unit_price,
                        discountType: dim_mst_discount_type_id,
                        discount: discount_price,
                        discountPercent: discount_value,
                        tax: "",
                        price_before_tax: 0,
                        dim_mst_vat_id: dimMstVat.id,
                        vat: dimMstVat.value,
                        note: remark,
                        price_after_tax: 0,
                        not_approve_reason: "",
                        is_checked: false,
                        edit: false
                    };
                    return mappingData;
                });
                dataWithReplacements.products = productItems;
                setProductRow(productItems);
            }
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev, dataWithReplacements), {
                    doc_number: prev.doc_number,
                    dimMstNewStatus: prev.dimMstNewStatus,
                    dim_mst_new_status_id: prev.dim_mst_new_status_id,
                    refer: prev.refer,
                    is_sort_manual: dataWithReplacements.is_sort_manual,
                    not_approve_reason: prev.not_approve_reason,
                    canceled_at: prev.canceled_at,
                    canceled_by_emp_id: prev.canceled_by_emp_id,
                    dim_new_purchase_req_id: dataWithReplacements.id,
                    pr_doc_number_ref: dataWithReplacements.doc_number
                });
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center  mb-3 flex-wrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "me-3 mb-2",
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control form-st-4",
                            placeholder: "เลขที่เอกสาร / ผู้จัดจำหน่าย",
                            onChange: function(e) {
                                return setFilterText(e.target.value);
                            },
                            value: filterText
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: function() {
                            return setFilterText("");
                        },
                        className: "btn btn btn-st-3 mb-2 px-4",
                        children: "ล้างค่าการค้นหา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    getRowId: function(row) {
                        return row.id;
                    },
                    getRowHeight: function() {
                        return "auto";
                    },
                    autoHeight: true,
                    rows: filteredItems,
                    columns: colum,
                    initialState: {
                        pagination: {
                            paginationModel: {
                                pageSize: 5
                            }
                        }
                    },
                    pageSizeOptions: [
                        10,
                        20,
                        30
                    ],
                    checkboxSelection: false,
                    disableRowSelectionOnClick: true,
                    slotProps: {
                        pagination: {
                            labelRowsPerPage: "จำนวนรายการต่อหน้า"
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center pb-4 pt-5 ",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-6 me-3 btn",
                        onClick: function() {
                            return setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-3 ",
                        onClick: function() {
                            loadPrData();
                            setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        disabled: !prSelected,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    });
}
